import { render, staticRenderFns } from "./CollapseLists.vue?vue&type=template&id=7f9723fd&"
import script from "./CollapseLists.vue?vue&type=script&lang=ts&"
export * from "./CollapseLists.vue?vue&type=script&lang=ts&"
import style0 from "./CollapseLists.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports